import { SmartLink } from '../../fragments/smart-link/SmartLink';

export default function CardLink({ url, isInternal, title, children }) {
  if (!url) return <>{children}</>;
  if (isInternal) {
    return (
      <SmartLink href={url} className="cardPost-link" data-cursor-arrow>
        {children}
      </SmartLink>
    );
  }
  return (
    <a href={url} target="_self" title={title} className="cardPost-link">
      {children}
    </a>
  );
}
